export function initDropdownButtons() {
    const buttons = document.querySelectorAll<HTMLElement>('.dropdown-button');
    let activeButton: HTMLElement | null = null;

    document.addEventListener('click', () => {
        if (activeButton) {
            activeButton.classList.remove('active');
            activeButton = null;
        }
    });

    buttons.forEach(element => {
        const button = element.querySelector<HTMLButtonElement>('button');
        button.addEventListener('click', (e) => {
            if (activeButton) {
                activeButton.classList.remove('active');

                if (activeButton === element) {
                    activeButton = null;
                    return;
                }
            }

            element.classList.add('active');
            activeButton = element;
            e.stopPropagation();
        });
    });
};